import { getBrand, getSocials, removeSocialMediaAccount } from "api";
import { useMemo, useState } from "react";
import { axiosInstance } from "api";
import { showAlert } from "utils/utils";
import { useEffect } from "react";

const useManageChannels = (brandId) => {
  const [selectedChannel, setSelectedChannel] = useState();
  const [loading, setLoading] = useState(true);
  const [brand, setBrand] = useState({});
  const [socials, setSocials] = useState([]);
  const [connecting, setConnecting] = useState(false);

  const platformList = useMemo(
    () => socials.map((item) => item.platform),
    [socials]
  );

  const fetchBrand = async () => {
    try {
      const brandRes = await getBrand(brandId);
      if (brandRes?.data?.status === true) setBrand(brandRes.data.data);
    } catch (e) {
      console.log(e)
    }
  }

  const loadSocials = async () => {
    const { search } = window.location;

    const error = new URLSearchParams(search).get("error");
    const success = new URLSearchParams(search).get("success");

    try {
      await fetchBrand();
      const socialsRes = await getSocials(brandId);
  
      if (socialsRes?.data?.status === true) {
        setSocials(socialsRes.data.data.socials);
      }
      // show alert after checking brand details
      if (success) {
        showAlert({
          msg: success,
          type: "success",
        });
      } else if (error) {
        showAlert({
          msg: error,
          type: "danger",
        });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      showAlert({
        msg: error,
        type: "Failed to fetch brand details",
      });
    }
  };

  const removeSocial = async () => {
    if (!selectedChannel) {
      return;
    }

    const { platform, id } = selectedChannel

    const data = {
      id,
      brandId,
      platform,
    };

    try {
      const res = await removeSocialMediaAccount(data);

      if (res.data.status === true) {
        await loadSocials();

        showAlert({
          type: "success",
          msg: `${platform} account removed`,
        });
      } else if (res.data.error) {
        showAlert({
          type: "danger",
          msg: res.data.error,
        });
      } else {
        showAlert({
          type: "danger",
          msg: `Error. Could not remove platform`,
        });
      }
    } catch (e) {
      showAlert({
        type: "danger",
        msg: `Error. Could not remove platform`,
      });
      console.log(e);
    }
  };

  const handleRemoveChannel = (channel) => {
    setSelectedChannel(channel);
    toggleShowOptions("");
    setTimeout(() =>
      document.querySelector("#confirmPlatformRemoval").classList.add("show")
    );
  };

  const toggleShowOptions = (id) => {
    document.querySelectorAll(".connected .options").forEach((el) => {
      if (el.dataset.id === id) {
        el.classList.toggle("open");
      } else {
        el.classList.remove("open");
      }
    });
  };

  const handleTokenRefresh = async (channel) => {
    const { platform } = channel;
    if (platform === "youtube") return;

    try {
      const res = await axiosInstance.get(`${platform}/${brandId}/refresh`);

      if (res?.data?.status === true) {
        const redirectUrl = res.data.redirect;
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }
        showAlert({
          msg: res.data.message,
          type: "success",
        });
      }
    } catch (e) {
      console.log(e);
      showAlert({
        msg:
          e.response.data.message ||
          "An error occurred. Could not refresh connection.",
        type: "danger",
      });
    }

    loadSocials();
  };

  const handleConnectPlatform = async (platform) => {
    setConnecting(true);
    try {
      const res = await axiosInstance.get(`${platform}/${brandId}/connect`);
      if (res?.data?.status === true) {
        const redirectUrl = res.data.redirect;
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }
      }
    } catch (e) {
      setConnecting(false);
      showAlert({
        msg:
          e.response.data.message ||
          "An error occurred. Could not complete the request.",
        type: "danger",
      });
    }

    setConnecting(false);
  };

  useEffect(() => {
    loadSocials();
    // eslint-disable-next-line
  }, [])

  return {
    fetchBrand,
    loadSocials,
    socials,
    platformList,
    removeSocial,
    handleRemoveChannel,
    toggleShowOptions,
    handleTokenRefresh,
    handleConnectPlatform,
    loading,
    brand,
    connecting,
  };
};

export default useManageChannels;
